// One slot per event-type slice, cycled if there are more event types than
// colors - `noData` is the single "nothing happened" placeholder slice.
export const OVERVIEW_CHART_COLORS = {
  palette: [
    '#8C9BED',
    '#FB923C',
    '#34D399',
    '#F472B6',
    '#60A5FA',
    '#FBBF24',
    '#A78BFA',
    '#4ADE80',
  ],
  noData: '#F7F7F8',
};
